import Dialog from '@mui/material/Dialog/Dialog';
import DialogContent from '@mui/material/DialogContent/DialogContent';
import React from 'react';
import { Breakpoint, Theme, useTheme } from '@mui/material/styles';
import { observer } from 'mobx-react';
import IconButton from '@mui/material/IconButton/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { createUseStyles } from 'react-jss';
import { modalStyle } from './ModalStyle';
import useMediaQuery from '@mui/system/useMediaQuery/useMediaQuery';

export interface ModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  breakpoint?: Breakpoint;
  header?: React.ReactNode;
  content?: React.ReactNode;
}

export default observer(function Modal({ title, isOpen, onClose, breakpoint = 'lg', header, content }: ModalProps) {
  const theme = useTheme();
  const classes = modalStyle({ theme });
  const fullScreen = useMediaQuery(theme.breakpoints.down(breakpoint));

  return (
    <Dialog
      open={isOpen}
      fullScreen={fullScreen}
      aria-labelledby='responsive-dialog-title'
      maxWidth={breakpoint}
      onClose={onClose}
      PaperProps={{
        className: breakpoint === 'lg' ? classes.modalBody : classes.modalBodySmall,
      }}
    >
      <DialogContent style={{ padding: 0, overflow: 'auto', display: 'flex', height: 100, flexDirection: 'column' }}>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5, color: '#EEE', zIndex: 99 }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <div style={{ padding: theme.spacing(2), background: theme.palette.bgZero.main, color: theme.palette.bgZero.contrastText, position: 'sticky', top: 0 }}>{title}</div>
        <div
          style={{
            background: theme.palette.bgTwo.main,
            color: theme.palette.bgTwo.contrastText,
            display: 'flex',
            justifyContent: 'center',
            boxShadow: `0px 3px 6px ${theme.palette.bgOne.main}`,
            zIndex: 10,
          }}
        >
          {header}
        </div>
        {content}
      </DialogContent>
    </Dialog>
  );
});
